import {
  Box, useTheme,
} from '@mui/material';
import OnboardingLayout from './OnboardingLayout';
import { MarketoForm } from '../../Marketo/MarketoForm';
import { OnboardFormV2 } from '../OnboardFormV2';
import {
  MARKETO_SERVICE_FUSION_BASE_URL,
  MARKETO_SERVICE_FUSION_FORM_ID,
  MARKETO_SERVICE_FUSION_MUNCHKIN_ID,
} from '../../../../common/constants';
import { useSolutionOrg } from '../../../../config/useSolutionOrg';

interface OnboardHomeComponentV2Props {
  onboardFormId: string;
}

export const OnboardHomeComponentV2 = ({
  onboardFormId,
}:OnboardHomeComponentV2Props) => {
  const theme = useTheme();
  const { envEnableMarketoDataSubmission } = useSolutionOrg();

  return (
    <OnboardingLayout
      reduceMobileTopPadding={true}
      optionalDesktopContainerStyle={{
        marginTop: theme.spacing(0),
      }}
    >
      <Box>
        {
          <>
            <OnboardFormV2
              onboardFormId={onboardFormId || ''}
              optionalBtnStyles={{
                background: theme.palette.brand.primary,
                borderRadius: theme.spacing(1.5),
                '&:hover': {
                  backgroundColor: theme.palette.brand.primary,
                },
                '&:disabled': {
                  backgroundColor: theme.palette.brand.primary,
                },
                marginTop: theme.spacing(0),
              }}
              noFooterText
            />
            {envEnableMarketoDataSubmission && <MarketoForm
              baseUrl={MARKETO_SERVICE_FUSION_BASE_URL}
              munchkinId={MARKETO_SERVICE_FUSION_MUNCHKIN_ID}
              formId={MARKETO_SERVICE_FUSION_FORM_ID}
            />}
          </>
        }
      </Box>
    </OnboardingLayout>
  );
};
